import { Application } from '@hotwired/stimulus';
import axios from 'axios';
import Cookies from 'js-cookie';
import Routing from '../dependencies/jsrouting-bundle/router.min.js';
import { DEFAULT_REGION_ID, normalizeRegionId } from '../utils/region-cookie';
import CinemaListController from '../stimulus/cinema_list_controller';
import RegionPickerController from '../stimulus/region_picker_controller';
import { setModal } from './modal/current';
import routes from '../../../public/js/fos_js_routes.json';

// MVK-3905 — phần JS chạy trên MỌI trang, tách khỏi `app.js` để entry Flowbite (`web`) dùng chung với entry Bootstrap (`app`)
// mà không kéo Bootstrap theo. Phần phụ thuộc vào modal đi qua adapter `modal` (shared/modal/*), không import trực tiếp.

// create root object
const root = {
    url: function(routeName, params) {
        return Routing.generate(routeName, params);
    },
    asset: function(path) {
        let baseUri = process.env.APP_CDN_URL;
        return baseUri + '/' + path;
    },
    loading: function() {
        return true;
    },
    getRegion: function() {
        const rawRegion = Cookies.get('region');
        const regionId = normalizeRegionId(rawRegion);
        if (regionId !== null) {
            return regionId;
        }
        // Cookie CÓ mặt nhưng hỏng (`null`, `undefined`, rỗng…): ghi đè ngay bằng mặc định để nó không
        // theo người dùng thêm 365 ngày nữa — với `region=null` thì mỗi ngày mang nó là một ngày ăn 403
        // toàn site. Cookie vắng mặt thì KHÔNG ghi gì, tránh đặt cookie cho khách mới. MVK-3037.
        if (typeof rawRegion !== 'undefined') {
            Cookies.set('region', DEFAULT_REGION_ID, { expires: 365 });
        }
        return DEFAULT_REGION_ID;
    },
    setRegion: function(region) {
        const regionId = normalizeRegionId(region);
        // Không bao giờ ghi giá trị hỏng vào cookie — xem MVK-3037.
        if (regionId === null) {
            return;
        }
        Cookies.set('region', regionId, { expires: 365 });
    },
    getCookie: function() {
        return Cookies;
    },
};

/**
 * @param {{show: Function, hide: Function, onShow: Function, isShown: Function}} modal adapter (shared/modal/*)
 */
export function boot(modal) {
    Routing.setRoutingData(routes);

    // Configure Axios global settings
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    // Add CSRF token interceptor
    axios.interceptors.request.use(function(config) {
        const csrfToken = document.querySelector('meta[name="csrf-token"]');
        if (csrfToken) {
            config.headers['X-CSRF-Token'] = csrfToken.getAttribute('content');
        }
        return config;
    }, function(error) {
        return Promise.reject(error);
    });

    // MVK-3407: hết Vue — hai modal chung (khu vực, rạp) là Stimulus controller nạp fragment Twig. Một Application riêng,
    // KHÔNG qua `assets/bootstrap.js`: bridge đó nạp eager ux-turbo + CSS tom-select cho mọi trang, và quét
    // `assets/controllers/` — controller ở đó sẽ bị đăng ký lần hai trên trang user/editor (hai lần fetch).
    // MVK-3314 (CSTI): HTML server không bao giờ là template phía client; tests/Twig/NoVueTest.php giữ điều đó.
    setModal(modal);
    RegionPickerController.root = root;
    CinemaListController.root = root;
    const stimulus = Application.start();
    stimulus.register('region-picker', RegionPickerController);
    stimulus.register('cinema-list', CinemaListController);
}
